const ArrowLeft = () => (
  <>
    <path
      fill="currentColor"
      d="m6.921 12.5 5.439 5.439a.48.48 0 0 1-.006.708.52.52 0 0 1-.354.162.49.49 0 0 1-.354-.163l-6.08-6.08a.8.8 0 0 1-.184-.268.8.8 0 0 1-.053-.298q0-.162.053-.298a.8.8 0 0 1 .183-.268l6.081-6.08a.5.5 0 0 1 .341-.15.48.48 0 0 1 .367.15q.165.165.165.356a.5.5 0 0 1-.165.357L6.92 11.5H18.5q.213 0 .357.143A.48.48 0 0 1 19 12a.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143z"
    />
  </>
)
export default ArrowLeft
